import { Box, Button } from '@mui/material'
import { Section } from '../section'
import { icons } from '../../../../../../utils/icons'
import { useTranslation } from 'react-i18next'
import EvidenceDetail from '../evidenceDetail'
import { useEvidences } from '../../../../../../hooks/evidences/useEvidences'
import { useEvidenceDownload } from '../../../../../calendar/pages/detail/hooks'
import { ActionPlanEvidence } from '../../../../../../service/actionPlans/actionPlanById'
import { Evidence } from '../../../../../../service/reportFolio/response'
import { SnackSimple } from '../../../../../../components'
import { useStyles } from './styles'

export type GeneralEvidencesSectionProps = {
  evidences?: ActionPlanEvidence[]
  id?: number
}

function GeneralEvidencesSection({ evidences, id }: GeneralEvidencesSectionProps) {
  const { t } = useTranslation()
  const styles = useStyles()
  const { evidences: evidenceLeft, existEvidences } = useEvidences({ evidencesResponse: evidences as Evidence[] })
  const {
    disable,
    openSnackbar,
    handleCloseSnackbar,
    downloadEvidences,
  } = useEvidenceDownload(`evidencias de plan de acción ${id}`, evidences as Evidence[])

  return (
    <Section icon={icons('clip')} title={t('actionPlan.sections.generalEvidences')}>
      <Box sx={styles.container}>
        <EvidenceDetail
          evidences={{
            image: evidenceLeft?.images,
            comment: evidenceLeft?.comments,
            documents: evidenceLeft?.documents,
            video: evidenceLeft?.video,
            sign: evidenceLeft?.sign,
          }}
          existEvidences={existEvidences}
        />

        {existEvidences && (
          <Box sx={styles.buttonContainer}>
            <Button
              variant='text_primary'
              onClick={downloadEvidences}
              disabled={disable}
            >
              {t('schedule.buttons.downloadEvidence')}
            </Button>
          </Box>
        )}
      </Box>

      <SnackSimple close={() => handleCloseSnackbar(false)} open={openSnackbar.open} type={openSnackbar.type as any} message={openSnackbar.message} />
    </Section>
  )
}

export { GeneralEvidencesSection }
